/* eslint-disable camelcase */
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchemaEditInvoiceAddressWithReference = () => {
  const { t } = useTranslation();

  const requiredMessage = t('common:validationMessages.required');

  const updateInvoiceAddressSchema = yup.object().shape({
    invoiceAddress_id: yup.number().required(requiredMessage),
    name: yup.string().required(requiredMessage),
    address: yup.string().required(requiredMessage),
    postalcode: yup.string().required(requiredMessage),
    city: yup.string().required(requiredMessage),
    country: yup.string().optional(),
    address2: yup.string().optional(),
    email: yup.string().optional(),
    name2: yup.string().optional(),
    invoiceReference: yup.string().required(requiredMessage),
  });
  return updateInvoiceAddressSchema;
};
